import React, { useState, useEffect, useRef } from "react";
import TeachableMachineHandler from "../implementations/TeachableMachineHandler";

function VideoPanel({ camera, isPlaying }) {
  const [predictions, setPredictions] = useState([]);
  const [initialPlay, setInitialPlay] = useState(false);
  const modelHandlerRef = useRef(null);
  const videoRef = useRef(null);

  useEffect(() => {
    // Initialize the Teachable Machine model when the component mounts
    modelHandlerRef.current = new TeachableMachineHandler(
      process.env.PUBLIC_URL
    );
    modelHandlerRef.current.loadModel();

    return () => {
      // Cleanup function to stop ongoing processes when the component unmounts
      if (modelHandlerRef.current) {
        // Additional cleanup if needed
      }
    };
  }, []);

  const predictFromVideo = async () => {
    const video = videoRef.current;

    if (video && modelHandlerRef.current) {
      // Wait for the video to be fully loaded
      if (video.readyState === 4) {
        const canvas = document.createElement("canvas");
        const context = canvas.getContext("2d");
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        context.drawImage(video, 0, 0, video.videoWidth, video.videoHeight);

        const predictions = await modelHandlerRef.current.predict(canvas);
        setPredictions(predictions);
      }
    }
  };

  useEffect(() => {
    // Make predictions when the video is playing
    if (isPlaying) {
      // const intervalId = setInterval(predictFromVideo, 1000); // Adjust the interval as needed

      return () => {
        // Cleanup function to stop making predictions when the video stops
        // clearInterval(intervalId);
      };
    }
  }, [isPlaying, camera.id]);

  return (
    <div key={camera.id} className="relative z-0">
      <div>{camera.name}</div>
      <video
        ref={videoRef}
        id={`video-${camera.id}`}
        controls
        muted
        autoPlay={false}
        loop
        onLoadedMetadata={() => {
          videoRef.current.playbackRate = 1.5;
          videoRef.current.play();
        }}
        className="w-full h-full"
      >
        <source src={camera.videoSource} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      {/* <div className="bg-gray-900 absolute bottom-4 right-4 p-4 rounded backdrop-blur bg-opacity-30">
        <div className="text-white font-bold mb-2 text-sm">
          Tracking Parameters
        </div>
        <div className="flex gap-4">
          <div className="flex flex-col gap-2">
            {predictions?.map((param, index) => (
              <div key={index} className="text-white text-xs">
                {param.className.toUpperCase()}
              </div>
            ))}
            <div className="text-white text-xs">Face Mask</div>
            <div className="text-white text-xs">No Face Mask</div>
            <div className="text-white text-xs">No Body Vest</div>
          </div>
          <div className="flex flex-col gap-2">
            {predictions?.map((param, index) => (
              <progress
                key={index}
                className="ml-2"
                value={param.probability * 100}
                max="100"
              ></progress>
            ))}
          </div>
        </div>
      </div> */}
    </div>
  );
}

export default VideoPanel;
